/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_NoteInputs */

const en_table_note = /** @type {(inputs: Table_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const ko_table_note = /** @type {(inputs: Table_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설명`)
};

const ja_table_note = /** @type {(inputs: Table_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Table_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const table_note = /** @type {((inputs?: Table_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_note(inputs)
	if (locale === "ko") return ko_table_note(inputs)
	return ja_table_note(inputs)
});